import { SearchTerm } from "./SearchTerm";

const OssDeviceSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "ossdName",
        translationKey: "name"
    },
];

export default OssDeviceSearch;
